const React = require('react');
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import {connect} from 'react-redux';
import {get} from 'lodash';
import {PaymentMethod} from 'modules/shared/types';
const i18n = require('../../../../i18n');
const PaypalForm = require('../modules/settings-money/paypal-form');
const PayoneerForm = require('../modules/settings-money/payoneer-form');
import BankForm from '../modules/settings-money/bank-account-form/controller/bank-account-form'

const SettingsMoney = createClass({

  propTypes: {
    currentUser: PropTypes.object
  },

  payoneerRegister() {
    const {currentUser} = this.props;

    API.getPayoneerUrl({
      _id: currentUser._id,
      callbackURL: `${window.location.origin}/settings/money`
    }, (err, res) => {
      if (err || res.code) return console.error(err, res);
      window.location.href = res;
    });
  },

  render() {
    const {currentUser} = this.props;
  
    const allowedPaymentMethods = get(this.props,'systemSettings.getMinCostsByPayment.available',[]).map((current) => (current.type))
    const paypalActive = allowedPaymentMethods.indexOf(PaymentMethod.PAYPAL) !== -1;
    const payoneerActive = allowedPaymentMethods.indexOf(PaymentMethod.PAYONEER) !== -1;
    const BankFormActive = allowedPaymentMethods.indexOf(PaymentMethod.TRANSFER) !== -1;

    return (
      <div className='vf-wrapper vf-settings-money vf-bg-white-color full-viewport-height'>
        <div className='vf-row'>
          <div className='col-xs-12'>
            <h3>{i18n.get('INF_SETTINGS_MONEY_DEPOSITS')}</h3>
          </div>
        </div>
        {
          paypalActive &&
          <div className='vf-row padding-top-2x'>
            <div className='col-xs-12'>
              <PaypalForm currentUser={currentUser} />
            </div>
          </div>
        }
        {
          payoneerActive  &&
          <div className='vf-row padding-top-2x'>
            <div className='col-xs-12'>
              <PayoneerForm currentUser={currentUser} />
            </div>
          </div>
        }
        {
          BankFormActive  &&
          <div className='vf-row padding-top-2x'>
            <div className='col-xs-12'>
              <BankForm currentUser={currentUser} />
            </div>
          </div>
        }
      </div>
    );
  }
});

function mapStateToProps({app}) {
  const {systemSettings} = app;
  return {
    systemSettings
  };
}

export default connect(mapStateToProps, null)(SettingsMoney);
